// extracted by mini-css-extract-plugin
export default {"menu":"Sidebar_menu__5eZFw","link":"Sidebar_link__aUXbi","groupHeader":"Sidebar_groupHeader__XI66X"};